import LoadingDataGrid from './LoadingDataGrid';

export default LoadingDataGrid;
